import axios from "axios"

export default axios.create({
    baseURL: "/pis/api/v1",
    headers: { 'Cache-Control': 'no-cache', 'Content-type': 'application/json; charset=UTF-8' }
});